
/*
Följer samma struktur här som gamla VK för baklängeskompatibilitet
*/

import { IAreaSelection } from "./marknadsprislistaFilter";

export class MarknadsprislistaFilterInstallningar {
    omradesFilter: IAreaSelection[];

    static get key() {
        return "Virkeskop.Pristabell.marknadsprislistaFilter";
    }
}
